<script setup lang="ts">

</script>

<template>
  <div class="z-20">
    <div
      class="pulsing-circle pulse-border bg-dark-blue w-[6rem] h-[6rem] md:w-[7.5rem] md:h-[7.5rem] flex items-center justify-center"
      style="border-radius: 100%"
    >
      <div class="absolute">
        <svgo-bankid class="w-70"></svgo-bankid>
      </div>
    </div>
  </div>
</template>

<style scoped>
@keyframes pulse-border {
  0% {
    box-shadow: 0 0 10px 5px rgb(255, 255, 255);
  }
  70% {
    box-shadow: 0 0 50px 20px rgba(255, 255, 255);
  }
  100% {
    box-shadow: 0 0 10px 5px rgba(255, 255, 255);
  }
}

.pulse-border {
  position: relative;
  z-index: 1;
}

.pulse-border::before {
  content: '';
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 3px solid #0A1E3F;
  border-radius: 50%;
  //animation: pulse-border 4s infinite;
}

.pulsing-circle {
  position: relative;
  transform-origin: center;
  transition: all 0.5s ease-out;
}
</style>
